module.exports = __webpack_public_path__ + "static/media/spiky_dj_tag_4.3de22aa7.mp3";